/* eslint-disable camelcase */
import sha1 from 'sha1';

const ERRORS = {
  'no-auth': ['401', '403', '621'],
};

const serverManager = {
  init(config) {
    const {
      server_url,
      login_url,
      oid,
      uid,
      key,
      sig,
      gameId,
      desktop,
    } = config;

    this.eventDispatcher = this.eventDispatcher || new createjs.EventDispatcher();

    this.config = {
      server_url,
      login_url,
      delta: 0,
    };

    this.params = {
      mobile: !desktop,
      lang: "ru",
      oid,
      uid,
      key,
      sig,
      gameId
    };

    return this.getStats();
  },

  addEventListener(evt, fn) {
    this.eventDispatcher = this.eventDispatcher || new createjs.EventDispatcher();
    this.eventDispatcher.addEventListener(evt, fn);
  },

  getStats() {
    return this.request('/start', this.params)
      .then(({ time, ticket, user }) => {
        this.config.delta = time - +new Date();

        const response = {
          balance: user.balance / 100,
          freeSpins: 0,
          freeSpinsDone: 0,
        };

        if (ticket) {
          response.freeSpins = ticket.free_spins;
          response.freeSpinsDone = ticket.spins_played;
          response.lines = ticket.lines;
          response.bet = ticket.bet / 100;
        }

        return response;
      });
  },

  play({ bet, lines }) {
    return this.request('/play', {
      lines,
      bet: bet * 100,
    }).then((res) => {
      return {
        win: res.win / 100,
        balance: res.balance / 100,
        spinWin: res.spin_win / 100 || 0,
        scatterWin: (res.scatter_win || 0) / 100,
        freeSpins: res.free_spins || 0,
        freeSpinsDone: res.spins_played || 0,
        lines: res.lines.map(line => line / 100),
        symbols: res.symbols,
        special: res.special,
      };
    });
  },

  finish() {
    return this.request('/finish').then((res) => {
      return res.balance / 100;
    });
  },

  playDouble() {
    return this.request('/double')
      .then(res => ({ win: res.win / 100 }));
  },

  urlencode(body) {
    return Object.keys(body).map(k =>
      `${encodeURIComponent(k)}=${encodeURIComponent(body[k])}`).join('&');
  },

  getQuery(args) {
    args.key = this.params.key;
    const query = this.urlencode(args);
    return query;
  },

  request(url, args = {}) {
    return fetch(this.config.server_url + url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: this.getQuery(args),
    })
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          return res;
        }

        throw new Error(res.status);
      })
      .then(res => res.json())
      .then((res) => {
        if (res.status === 'fail') {
          throw new Error(res.error_code);
        }

        return res;
      })
      .catch((err) => {
        const knownError = Object.keys(ERRORS).find(k => ERRORS[k].includes(err.message));
        this.eventDispatcher.dispatchEvent(knownError || 'error');

        throw err;
      });
  },
};

export default serverManager;



// WEBPACK FOOTER //
// ../base/js/managers/server.js